
import Vue from "vue";
import { SyncManagers } from "../Sync";
import { UserID } from "../Utils";
import { evalExpr } from "../math";
import { s } from "../L10n";

export default Vue.extend({
  props: {
    ledgerId: String,
    id: String,
  },
  data() {
    const sync = SyncManagers.get(this.ledgerId);
    let item;
    if (this.id == 'new') {
      item = sync.newTransaction();
    } else {
      item = sync.getItem(this.id);
    }
    if (!item) {
      throw Error();
    }
    return {
      sync,
      item,
      description: item.description.content as string,
      amount: item.amount.content.toString() as string,
      currency: item.currency.content as string,
      date: item.effective_ts.content,
      paidBy: item.paidBy.content as UserID,
      paidFor: item.paidFor.content as UserID[],
      participantList: sync.participantList,
    };
  },
  methods: {
    onClick() {
      if (this.evalAmount == null) return;
      const item = this.item;
      item.update(this.description, this.evalAmount, this.currency, this.date, this.paidBy, this.paidFor, new Array(this.paidFor.length).fill(1));
      this.sync.setItem(item);
      this.$router.push({ name: 'ledger', params: {id: this.ledgerId}});
    },
    back() {
      this.$router.push({ name: 'ledger', params: {id: this.ledgerId}});
    },
    s(str: string): string {
      return s(str);
    }
  },
  computed: {
    disabled(): boolean {
      return this.evalAmount == null || !this.paidBy || !this.description;
    },
    evalAmount(): number | null {
      const amt = this.amount;
      const filteredAmount = amt.replace(/[^0-9+\-*/().]/g, '');
      if (filteredAmount !== amt) {
        this.amount = filteredAmount;
      }
      return evalExpr(this.amount);
    },
    currencies(): Array<{value: string, text: string, disabled?: boolean}> {
      return [
        {value: "EUR", text: this.s("EUR")},
        {value: "USD", text: this.s("USD")},
        {value: "GBP", text: this.s("GBP")},
        {value: "JPY", text: this.s("JPY")},
        {value: "INR", text: this.s("INR")},
        {value: "TND", text: this.s("TND")},
        {value: "CNY", text: this.s("CNY")},
        {value: "KRW", text: this.s("KRW")},
        {value: "AUD", text: this.s("AUD")},
        {value: "CAD", text: this.s("CAD")},
        {value: "Crypto", text: this.s("Crypto"), disabled: true},
        {value: "BTC", text: this.s("BTC")},
        {value: "ETH", text: this.s("ETH")},
        {value: "XMR", text: this.s("XMR")},
      ];
    },
  },
});
